/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_EyebrowInputs */

const en_landing_guide_eyebrow = /** @type {(inputs: Landing_Guide_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram AI 4.5 guide`)
};

const zh_landing_guide_eyebrow = /** @type {(inputs: Landing_Guide_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram AI 4.5 指南`)
};

/**
* | output |
* | --- |
* | "Ideogram AI 4.5 guide" |
*
* @param {Landing_Guide_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_eyebrow = /** @type {((inputs?: Landing_Guide_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_eyebrow(inputs)
	return zh_landing_guide_eyebrow(inputs)
});
export { landing_guide_eyebrow as "landing.guide.eyebrow" }